export enum FlowTypes {
  CHARITY = 'charity',
  PARTNER = 'partner',
  TERRITORY = 'territory',
}
